import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import ListIcon from "@mui/icons-material/List";
import VisibilityOutlinedIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import MDBadge from "components/MDBadge";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { Dropdown, Select } from "semantic-ui-react";
import Paper from "@mui/material/Paper";
import colors from "assets/theme/base/colors";
import "react-toastify/dist/ReactToastify.css";
import "../campus/Campus.css";
import { set } from "lodash";
import AssignDegreesDialog from "./AssignDegreesDialog";
import { hasAdmissionPermission } from "hooks/permissions";
const { info } = colors;

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const Batch = () => {
  // State variables
  const [batches, setBatches] = useState([]);
  const [name, setName] = useState("");
  const [year, setYear] = useState("");
  const [type, setType] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [showAddBatchModal, setShowAddBatchModal] = useState(false);
  const [showUpdateBatchModal, setShowUpdateBatchModal] = useState(false);
  const [showViewBatchModal, setShowViewBatchModal] = useState(false);
  const [showDeleteBatchModal, setShowDeleteBatchModal] = useState(false);
  const [showAssignDegreesModal, setShowAssignDegreesModal] = useState(false);
  const [currentBatchId, setCurrentBatchId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
    year: "",
    type: "",
    batchCode: "",
    startDate: "",
    endDate: "",
    status: "",
  });
  const [degrees, setDegrees] = useState([]);

  // Dummy data for batches
  const dummyData = [
    {
      id: 1,
      name: "Batch A",
      year: "2023",
      type: "Part-time",
      batch_code: "A2023",
      start_date: "2023-01-01T00:00:00Z",
      end_date: "2023-12-31T00:00:00Z",
      status: "Active",
    },
    {
      id: 2,
      name: "Batch B",
      year: "2024",
      type: "Full-time",
      batch_code: "B2024",
      start_date: "2024-01-01T00:00:00Z",
      end_date: "2024-12-31T00:00:00Z",
      status: "Active",
    },
    {
      id: 3,
      name: "Batch C",
      year: "2025",
      type: "Full-time",
      batch_code: "C2025",
      start_date: "2025-01-01T00:00:00Z",
      end_date: "2025-12-31T00:00:00Z",
      status: "Active",
    },
  ];

  // Fetch batches
  const getBatches = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await fetch(
        `${BASE_URL}/batch/get_batches`,
        requestOptions
      );
      console.log("Response status:", response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Data received:", data);
      setBatches(data.batches);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  // Add batch
  const addBatch = async () => {
    const batchData = {
      name,
      year,
      type,
      batch_code: batchCode,
      start_date: startDate,
      end_date: endDate,
      status,
    };

    try {
      const response = await fetch(`${BASE_URL}/batch/create_batch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(batchData),
      });

      if (!response.ok) {
        const errorMessage = `Failed to add batch: ${response.statusText}`;
        throw new Error(errorMessage);
      }

      const newBatch = await response.json();
      setBatches((prevBatches) => [...prevBatches, newBatch]);
      getBatches();
      toast.success("Session added successfully");
      resetForm();
    } catch (error) {
      console.error("Error adding batch:", error);
      toast.error(error.message || "Failed to add batch");
    } finally {
      setShowAddBatchModal(false);
    }
  };

  // Update batch
  const updateBatch = async () => {
    if (!validateBatchForm()) return;

    const data = {
      id: currentBatchId,
      name,
      year,
      type,
      batch_code: batchCode,
      start_date: startDate,
      end_date: endDate,
      status,
    };

    try {
      const response = await fetch(`${BASE_URL}/batch/update_batch`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || "Failed to update batch");
      }

      const updatedBatch = await response.json();
      setBatches((prevBatches) =>
        prevBatches.map((batch) =>
          batch.id === currentBatchId ? updatedBatch : batch
        )
      );
      toast.success("Session updated successfully");
    } catch (error) {
      console.error("Error updating batch:", error);
      toast.error("Failed to update batch");
      r;
    } finally {
      getBatches();
      setShowUpdateBatchModal(false);
      resetForm(); 
    }
  };

  // Delete batch
  const deleteBatch = async () => {
    try {
      console.log("Deleting batch with ID:", currentBatchId);
      const response = await fetch(
        `${BASE_URL}/batch/delete_batch/${currentBatchId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Response status:", response.status);

      if (!response.ok) {
        const errorResponse = await response.json();
        console.error("Error response:", errorResponse);
        throw new Error(errorResponse.message || "Failed to delete batch");
      }

      setBatches((prevBatches) =>
        prevBatches.filter((batch) => batch.id !== currentBatchId)
      );
      toast.success("Session deleted successfully");
    } catch (error) {
      console.error("Error deleting batch:", error);
      toast.error(error.message || "Failed to delete batch");
    } finally {
      setShowDeleteBatchModal(false);
    }
  };

  const viewBatch = (id) => {
    const batch = batches.find((d) => d.id === id);
    setSelectedBatch(batch);
    setShowViewBatchModal(true);
  };
  const getDegrees = async () => {
    try {
      const response = await fetch(`${BASE_URL}/degree/get_degrees`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch degrees");
      }
      const data = await response.json();
      setDegrees(data.degrees);
    } catch (error) {
      console.error("Error fetching degrees:", error);
    }
  };
  // Search functionality
  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getBatches();
    } else {
      const filteredBatches = batches.filter((batch) => {
        const nameMatch =
          batch.name && batch.name.toLowerCase().includes(searchTerm);
        const yearMatch =
          batch.year && batch.year.toLowerCase().includes(searchTerm);
        const typeMatch =
          batch.type && batch.type.toLowerCase().includes(searchTerm);
        const batchCodeMatch =
          batch.batch_code &&
          batch.batch_code.toLowerCase().includes(searchTerm);
        return nameMatch || yearMatch || typeMatch || batchCodeMatch;
      });
      setBatches(filteredBatches);
    }
  };

  const validateBatchForm = () => {
    const errors = {};
    if (name.trim() === "") {
      errors.name = " * Batch name is required";
    }
    if (year.trim() === "") {
      errors.year = " * Year is required";
    }
    if (type.trim() === "") {
      errors.type = " * Batch type is required";
    }
    if (batchCode.trim() === "") {
      errors.batchCode = " * Batch code is required";
    }
    if (startDate.trim() === "") {
      errors.startDate = " * Start date is required";
    }
    if (endDate.trim() === "") {
      errors.endDate = " * End date is required";
    }
    if (!status || status.trim() === "") { // Check if status is defined and not empty
      errors.status = " * Status is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setName("");
    setYear("");
    setType("");
    setBatchCode("");
    setStartDate("");
    setEndDate("");
    setStatus("");
  };

  // Dialog handlers
  const showBatchAddModal = () => {
    resetForm(); 
    setShowAddBatchModal(true);
  };
  const showBatchUpdateModal = (id) => {
    setCurrentBatchId(id);
    const batch = batches.find((b) => b.id === id);
    setName(batch.name);
    setYear(batch.year);
    setType(batch.type);
    setBatchCode(batch.batch_code);
    setStartDate(batch.start_date.split("T")[0]);
    setEndDate(batch.end_date.split("T")[0]);
    setStatus(batch.status || ""); 
    setShowUpdateBatchModal(true);
  };

  const showBatchDeleteModal = (id) => {
    setCurrentBatchId(id);
    setShowDeleteBatchModal(true);
  };
  const handleShowAssignDegreesModal = (id) => {
    setCurrentBatchId(id);
    setShowAssignDegreesModal(true);
  };
  // Initial render
  useEffect(() => {
    getBatches();
    getDegrees();
  }, []);

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Session Name", accessor: "name", align: "center" },
    { Header: "Year", accessor: "year", align: "center" },
    { Header: "Type", accessor: "type", align: "center" },
    { Header: "Session Code", accessor: "batch_code", align: "center" },
    { Header: "Start Date", accessor: "start_date", align: "center" },
    { Header: "End Date", accessor: "end_date", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = batches.map((batch, index) => ({
    serial: index + 1,
    name: batch.name,
    year: batch.year,
    type: batch.type,
    batch_code: batch.batch_code,
    start_date: new Date(batch.start_date).toLocaleDateString(),
    end_date: new Date(batch.end_date).toLocaleDateString(),
    status: (
      <MDBox ml={-1}>
            <MDBadge
                badgeContent={batch.status}
                color={batch.status === "Active" ? "success" : "error"}
                variant="gradient"
                size="sm"
            />
        </MDBox>
    ),
    actions: (
      <>
      {hasAdmissionPermission("Session", "UPDATE") && (
        <IconButton onClick={() => showBatchUpdateModal(batch.id)}>
          <EditIcon className="icon-button-edit" />
        </IconButton>
      )}
      {hasAdmissionPermission("Session", "READ") && (
        <IconButton onClick={() => viewBatch(batch.id)}>
          <VisibilityOutlinedIcon className="icon-button-view" />
        </IconButton>
      )}
        {hasAdmissionPermission("Session", "DELETE") && (
        <IconButton onClick={() => showBatchDeleteModal(batch.id)}>
          <DeleteIcon className="icon-button-delete" />
        </IconButton>
        )}
        {/* <IconButton onClick={() => handleShowAssignDegreesModal(batch.id)}>
          <ListIcon className="icon-button-assign" />
        </IconButton> */}
      </>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Paper component="form" className="search-paper">
                  <InputBase
                    sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search batch" }}
                    value={searchKeyword}
                    onChange={handleSearchKeywordChange}
                  />
                  <SearchIcon className="search-icon" />
                </Paper>
                {hasAdmissionPermission("Session", "CREATE") && (
                <Button
                  variant="filled"
                  endIcon={<AddIcon className="add-icon" />}
                  onClick={showBatchAddModal}
                  className="add-button"
                >
                  Add
                </Button>
                )}
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Batch Dialog */}
      <Dialog
        open={showAddBatchModal}
        onClose={() => setShowAddBatchModal(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Add Session"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Session Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Session Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Session Year</label>
                <input
                  name="year"
                  type="text"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Year"
                />
              </div>
              <div className="error-message">{formErrors.year}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Session Type</label>
                <Select
                  name="batch_type"
                  placeholder="Select Session Type"
                  fluid
                  selection
                  value={type}
                  onChange={(e, { value }) => setType(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Fall", value: "Fall" },
                    { key: 2, text: "Summer", value: "Summer" },
                    { key: 3, text: "Spring", value: "Spring" },
                    { key: 4, text: "Annual", value: "Annual" },
                  ]}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.type}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Session Code</label>
                <input
                  name="batch_code"
                  type="text"
                  value={batchCode}
                  onChange={(e) => setBatchCode(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Session Code"
                />
              </div>
              <div className="error-message">{formErrors.batchCode}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Start Date</label>
                <input
                  name="start_date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.startDate}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>End Date</label>
                <input
                  name="end_date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message">{formErrors.endDate}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Status</label>
                <Select
                  placeholder="Select Status"
                  fluid
                  sx={{ height: "40px" }}
                  selection
                  value={status}
                  onChange={(e, { value }) => setStatus(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Active", value: "Active" },
                    { key: 0, text: "Inactive", value: "Inactive" },
                  ]}
                 className="form-control form-control-lg"
                />
              </div>
              <div className="error-message">{formErrors.status}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ marginRight: "20px" }}>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowAddBatchModal(false)}
          >
            Cancel
          </Button>
          <Button className="dialog-actions-button positive" onClick={addBatch}>
            Add
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Batch Dialog */}
      <Dialog
        open={showUpdateBatchModal}
        onClose={() => setShowUpdateBatchModal(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Update Session"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Session Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Session Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Session Year</label>
                <input
                  name="year"
                  type="text"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Year"
                />
              </div>
              <div className="error-message">{formErrors.year}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Session Type</label>
                <Select
                  name="batch_type"
                  placeholder="Select Session Type"
                  fluid
                  selection
                  value={type}
                  onChange={(e, { value }) => setType(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Fall", value: "Fall" },
                    { key: 2, text: "Summer", value: "Summer" },
                    { key: 3, text: "Spring", value: "Spring" },
                    { key: 4, text: "Annual", value: "Annual" },
                  ]}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.type}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>Session Code</label>
                <input
                  name="batch_code"
                  type="text"
                  value={batchCode}
                  onChange={(e) => setBatchCode(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Session Code"
                />
              </div>
              <div className="error-message">{formErrors.batchCode}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Start Date</label>
                <input
                  name="start_date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.startDate}</div>
            </div>

            <div className="col-md-6">
              <div className="mt-3">
                <label>End Date</label>
                <input
                  name="end_date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message">{formErrors.endDate}</div>
            </div>

            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Status</label>
                <Select
                  id="status"
                  placeholder="Select Status"
                  fluid
                  selection
                  value={status}
                  onChange={(e, { value }) => setStatus(value)} 
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Active", value: "Active" },
                    { key: 0, text: "Inactive", value: "Inactive" },
                  ]}
               className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.status}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ marginRight: "20px" }}>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowUpdateBatchModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={updateBatch}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Batch Dialog */}
      <Dialog
        open={showDeleteBatchModal}
        onClose={() => setShowDeleteBatchModal(false)}
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          Delete Session
        </DialogTitle>
        <DialogContent className="content-delete">
          Are you sure you want to delete this session?
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowDeleteBatchModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={deleteBatch}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Batch Dialog */}
      <Dialog
        open={showViewBatchModal}
        onClose={() => setShowViewBatchModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Session
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedBatch && (
            <>
              <div className="flex-container">
                <strong className="label1">Name</strong>
                <span className="value1">{selectedBatch.name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Year</strong>
                <span className="value1">{selectedBatch.year}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Type</strong>
                <span className="value1">{selectedBatch.type}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Session Code</strong>
                <span className="value1">{selectedBatch.batch_code}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Start Date</strong>
                <span className="value1">
                  {new Date(selectedBatch.start_date).toLocaleDateString()}
                </span>
              </div>
              <div className="flex-container">
                <strong className="label1">End Date</strong>
                <span className="value1">
                  {new Date(selectedBatch.end_date).toLocaleDateString()}
                </span>{" "}
              </div>
              <div className="flex-container">
                <strong className="label1">Status</strong>
                <span className="value1">{selectedBatch.status}</span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowViewBatchModal(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
          <AssignDegreesDialog
            showAssignDegreesModal={showAssignDegreesModal}
            setShowAssignDegreesModal={setShowAssignDegreesModal}
          />
    </DashboardLayout>
  );
};

export default Batch;
